export default __webpack_public_path__ + "static/media/profile6.98666144.png";